<template lang="pug">
v-dialog(v-model="showDebtorDetailDialog" :fullscreen="$vuetify.breakpoint.mdAndDown" max-width="700" persistent scrollable)
    v-snackbar( v-model="snackbar" :color="snackbarColor" ) {{ snackbarMessage }}
        template( v-slot:action="{attrs}")
            v-btn(text v-bind="attrs"
                @click="snackbar = false") {{ $t('buttons.closeButtonLabel') }}
    v-card
        v-card-title {{ debtor.person.firstName }} {{ debtor.person.familyName }}
        v-tabs(v-model="tab")
            v-tab {{ $t('debtorDetailDialog.billingsTabTitle') }}
            v-tab {{ $t('debtorDetailDialog.contactsTabTitle') }}
        v-card-text(style="height: 50vh;")
            v-tabs-items(v-model="tab")
                v-tab-item
                    v-data-table(
                        v-if="debtorDetails"
                        :headers="headers" :items="debtorDetails.debtInvoices"
                        disable-pagination hide-default-footer
                    )
                        template(v-slot:item.formattedPriceItemSum="{ item }")
                            div.text-end {{ item.formattedPriceItemSum }} €
                        template(v-slot:item.formattedAmountAlreadyPaid="{ item }")
                            div.text-end {{ item.formattedAmountAlreadyPaid }} €
                        template(v-slot:item.formattedOutstandingAmountToPay="{ item }")
                            div.text-end {{ item.formattedOutstandingAmountToPay }} €

                    v-skeleton-loader( v-else type="list-item@5" )

                v-tab-item
                    v-skeleton-loader( v-if="fetchInProgress" type="list-item@5" )

                    v-list(v-else-if="(this.phoneNumber !== undefined || this.phoneNumber !== '') || this.emailList.length !== 0" )
                      v-list-item
                        v-list-item-content
                          v-list-item-title {{ $t('debtorDetailDialog.phoneNumberLabel') }}
                          v-list-item-subtitle(v-if="this.phoneNumber === undefined") {{ $t('debtorDetailDialog.noPhoneNumberText') }}
                          v-list-item-subtitle(v-else).font-weight-bold {{ this.phoneNumber }}

                      v-list-item(v-for="(email, idx) in this.emailList" :key="idx")
                        v-list-item-content
                          v-list-item-title {{ $t('debtorDetailDialog.emailLabel') }}
                          v-list-item-subtitle.font-weight-bold {{ email.email }}

                    div(v-else).font-weight-bold {{ $t('debtorDetailDialog.noContactsText') }}
        v-divider
        v-card-actions
            v-spacer
            v-btn( @click="onCloseButtonClick" text color="primary" ) {{ $t('buttons.closeButtonLabel') }}
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import {Debt} from "@/model/debtors/Debt";
import {Action} from "vuex-class";
import {FETCH_BOARDER_DETAIL, FETCH_DEBTOR_DETAIL} from "@/store/action-types";
import i18n from "@/plugins/i18n";
import {DataTableHeader} from "vuetify";
import {AccountEmail} from "@/model/AccountEmail";
import {FetchBoarderDetailPayload} from "@/types/payload";
import {BoarderDetailResponse} from "@/types/service-response";

@Component({
  components: {}
})

export default class DebtorDetailDialog extends Vue {
  @Prop({type: Boolean, default: false}) showDebtorDetailDialog!: boolean
  @Prop({type: Object as () => Debt}) debtor!: Debt

  @Action(FETCH_DEBTOR_DETAIL) fetchDebtorDetail!: ({ (id: number): Promise<Debt> })
  @Action(FETCH_BOARDER_DETAIL) fetchBoarderDetails!: ({ (payload: FetchBoarderDetailPayload): Promise<BoarderDetailResponse> })


  private tab: number = 0

  private headers: DataTableHeader[] = [
    {text: i18n.t('debtorDetailDialog.tableHeaderInvoiceName').toString(), align: 'start', sortable: false, value: 'name'},
    {text: i18n.t('debtorDetailDialog.tableHeaderPriceItemSum').toString(), value: 'formattedPriceItemSum' },
    {text: i18n.t('debtorDetailDialog.tableHeaderAmountAlreadyPaid').toString(), value: 'formattedAmountAlreadyPaid'},
    {text: i18n.t('debtorDetailDialog.tableHeaderOutstandingAmountToPay').toString(), value: 'formattedOutstandingAmountToPay'},
  ]

  private snackbar: boolean = false
  private snackbarMessage: string = ''
  private snackbarColor: string = ''

  private debtorDetails: Debt | null = null

  private fetchInProgress: boolean = false
  private phoneNumber: string = ''
  private emailList: AccountEmail[] = []


  onCloseButtonClick(): void {
    this.closeDialog()
  }

  closeDialog(): void {
    this.$emit('closeDebtorDetailDialog')
  }

  async fetchDebtorDetails(): Promise<void> {

    try {
      this.debtorDetails = await this.fetchDebtorDetail(this.debtor.id)
    } catch (e) {
      this.snackbar = true
      this.snackbarMessage = this.$t('errors.fetchDataError').toString()
      this.snackbarColor = "alert"
    }
  }

  async fetchDetailsAboutBoarder(): Promise<void> {
    this.fetchInProgress = true

    let payload: FetchBoarderDetailPayload = {
      id: this.debtor.person.id
    }

    try {
      const response: BoarderDetailResponse = await this.fetchBoarderDetails(payload)
      this.phoneNumber = response.phoneNumbers[0]?.phoneNumber
      this.emailList = AccountEmail.createFromBoarderDetailResponse(response)
    } catch (e) {
      this.snackbar = true
      this.snackbarMessage = this.$t('errors.fetchDataError').toString()
      this.snackbarColor = "alert"
    } finally {
      this.fetchInProgress = false
    }
  }

  mounted(): void {
    this.fetchDebtorDetails()
    this.fetchDetailsAboutBoarder()
  }
}
</script>

<style lang="stylus" scoped>

</style>